import * as FSR from "src/generated/hooks/form-service/requests";
import { exponentialBackoff } from "src/hooks/useDynamicPolling";
import { rankHasMayHavePendingAutoDecisions } from "./mergeAdmissionsIntoFormSchoolRanks";

export const ADMISSIONS_POLL_BASE_INTERVAL_MS = 1_000;
export const ADMISSIONS_POLL_MAX_INTERVAL_MS = 30_000;
export const ADMISSIONS_MAX_POLL_DURATION_MS = 10 * 60 * 1000;

const getBackoffPollInterval = exponentialBackoff(
  ADMISSIONS_POLL_BASE_INTERVAL_MS,
  1.25,
  ADMISSIONS_POLL_MAX_INTERVAL_MS
);

export function shouldPollAdmissions(
  admissions: FSR.GetAdmissionsForMeResponse
): boolean {
  return rankHasMayHavePendingAutoDecisions(admissions);
}

export function getAdmissionsPollIntervalMs(pollAttempt: number): number {
  let interval = ADMISSIONS_POLL_BASE_INTERVAL_MS;
  for (let attempt = 0; attempt < pollAttempt; attempt++) {
    interval = getBackoffPollInterval(interval);
  }
  return interval;
}
